import gql from 'graphql-tag';
import {flowRight as compose} from 'lodash';
import * as PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Mutation, withApollo} from 'react-apollo';
import {Col, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {withRouter} from 'react-router';
import {PulseLoader} from 'react-spinners';
import Error from '../../../../common/components/Error/Error';
import {
  CancelButton,
  Div,
  FooterRow,
  GradientCol,
  Input,
  TitleButton,
} from '../../../../common/components/StyledComp';
import Tooltip from '../../../../common/components/Tooltip';
import {GRAPHQL_MUTATION_UPDATE_CHECKOUT} from '../../../../common/queries/checkout';

const GRAPHQL_QUERY_CHECKOUT = gql`
    query checkout($id:ID!){
        checkout(id: $id){
            id
            serial
            name
            isActive
            merchant{
                id
                businessName
                brand{
                    id
                    name
                }
                user{
                    id
                    firstName
                    lastName
                }
            }
            createdAt
        }
    }
`;

class Details extends Component {
    state = {
      modalVisible: false,
      newCheckout: {serial: '', name: ''},
      submitted: false,
      checkoutLoading: true,
    };

    componentDidMount() {
      const {match, client, checkoutId} = this.props;
      const checkoutID = checkoutId ? checkoutId : match.params.id || null;
      client
        .query({
          query: GRAPHQL_QUERY_CHECKOUT,
          variables: {
            id: checkoutID,
          },
        })
        .then(({data}) => {
          this.setState({
            newCheckout: data.checkout,
            checkoutLoading: false,
          });
        })
        .catch(error => {
          console.error('Error : ', error);
        });
    }

    setModalVisible = value => {
      this.setState({modalVisible: value});
    };

    setNewCheckout = value => {
      this.setState({newCheckout: value});
    };

    setSubmitted = value => {
      this.setState({submitted: value});
    };

    render() {
      const {t, history} = this.props;

      const {newCheckout, submitted, checkoutLoading} = this.state;

      const {id, serial, name} = newCheckout;

      if (checkoutLoading) {
        return <PulseLoader />;
      } else if (!newCheckout) {
        return <h4>{t('noCheckout')}</h4>;
      }
      return (
        <Mutation
          mutation={GRAPHQL_MUTATION_UPDATE_CHECKOUT}
          onCompleted={() => history.push('/admin/checkouts')}
          refetchQueries={['checkouts']}
        >
          {(updateCheckout, {loading, error}) => {
            if (loading) {
              return <PulseLoader loading={loading}/>;
            } else {
              return (
                <>
                  <Row>
                    <Col xs={{span: 8, offset: 2}} className="extended-col">
                      <Div className="attribute-name">{`${t('serial')} : `}</Div>
                      <PulseLoader loading={loading}/>
                      <Input
                        type="text"
                        value={newCheckout.serial}
                        name="serial"
                        onChange={e => {
                          this.setSubmitted(false);
                          this.setNewCheckout({...newCheckout, serial: e.target.value});
                        }}
                        disabled
                      />
                      <Tooltip show={newCheckout.serial === '' && submitted} color="red">
                        {t('addCheckout.requiredField')}
                      </Tooltip>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={{span: 8, offset: 2}} className="extended-col">
                      <Div className="attribute-name">{`${t('name')} : `}</Div>
                      <PulseLoader loading={loading}/>
                      <Input
                        type="text"
                        value={newCheckout.name}
                        name="name"
                        onChange={e => {
                          this.setSubmitted(false);
                          this.setNewCheckout({...newCheckout, name: e.target.value});
                        }}
                        required
                      />
                    </Col>
                  </Row>
                  <FooterRow>
                    <GradientCol sm={{span: 6, offset: 3}}>
                      <Error error={error}/>
                      <div className="popin-buttons">
                        <TitleButton
                          disabled={loading}
                          onClick={() => {
                            this.setSubmitted(true);
                            if (newCheckout.serial !== '') {
                              updateCheckout({
                                variables: {
                                  checkoutInput: {
                                    id,
                                    serial,
                                    name,
                                  },
                                },
                              });
                            }
                          }}
                        >
                          {t('save')}
                        </TitleButton>
                        <CancelButton
                          onClick={() => history.push('/admin/checkouts')}
                          style={{marginTop: 0, width: 'auto'}}>
                          {t('cancel')}
                        </CancelButton>
                      </div>
                    </GradientCol>
                  </FooterRow>
                </>
              );
            }
          }}
        </Mutation>
      );
    }
}

Details.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  checkoutId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default compose(
  withTranslation('checkout'),
  withApollo,
  withRouter,
)(Details);
